// extracted by mini-css-extract-plugin
export var activeFilterButton = "_m4-c";
export var backButton = "_m4-4";
export var backIcon = "_m4-5";
export var chevronShortcut = "_m4-6";
export var container = "_m4-1";
export var editor = "_m4-8";
export var editorWrapper = "_m4-7";
export var prefix = "_m4-2";
export var searchIcon = "_m4-3";
export var suffix = "_m4-9";
export var suffixContent = "_m4-a";
export var suffixText = "_m4-b";
export var wrapper = "_m4-0";